module.exports = __webpack_public_path__ + "img/DE05896.30fefa30.png";